import "./GoogleTopQualityStores.scss";

// This is a work around for the CLS caused by the Google Top Quality Stores badge.
// The iframe containing the badge is initially set to 450px wide and gets changed to 84px after an animation finishes.
// This causes CLS and needs to be worked around.
// I did this by keeping the width of the container and the iframe to 270px (it really doesn't need the full 450px)
// Until the user interacts with the page. Pointerdown and keydown will not count towards CLS, but scroll will.
// However, I'm willing to take the minor hit caused by scroll in order to ensure the sapcer is gone when the user wants to interact with something on the page that may be covered by the badge's iframe.

export class GoogleTopQualityStores
{
	private Badge: HTMLElement | null = null;

	constructor()
	{
		// Check if it already exists first
		const existing = document.querySelector("#___ratingbadge_0") as HTMLElement | null;

		if (existing)
		{
			this.GtsInserted(existing);
		}

		else
		{
			// Create observer
			const observer = new MutationObserver((mutations, obs) =>
			{
				const el = document.querySelector("#___ratingbadge_0") as HTMLElement | null;

				if (el)
				{
					this.GtsInserted(el);
					obs.disconnect(); // Stop observing once found
				}
			});

			// Observe the whole document for additions
			observer.observe(document.documentElement, {
				childList: true,
				subtree: true,
			});
		}
	};

	public GtsInserted = (badge: HTMLElement): void =>
	{
		if (this.Badge) return;

		this.Badge = badge;

		// Add event listeners to capture first page interaction
		window.addEventListener("pointerdown", this.UnlockGts, true);
		window.addEventListener("keydown", this.UnlockGts, true);
		window.addEventListener("scroll", this.UnlockGts, { capture: true, passive: true });
		badge.addEventListener("mouseover", this.UnlockGts, true);
	}

	public UnlockGts = (): void =>
	{
		if (this.Badge !== null)
		{
			// Add an unlocked class to offset the CLS
			this.Badge.classList.add("gtsUnlocked");
			this.Badge.removeEventListener("mouseover", this.UnlockGts, true);
		}

		// Remove the event listeners manually
		window.removeEventListener("pointerdown", this.UnlockGts, true);
		window.removeEventListener("keydown", this.UnlockGts, true);
		window.removeEventListener("scroll", this.UnlockGts, true);
	};
}